import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { getSession, clearSession } from '../../services/localStorage';

const Header = () => {
  const navigate = useNavigate();
  const [session, setSessionState] = useState(null);
  const [sessionTime, setSessionTime] = useState('0h 0m');

  // Load session and update time
  useEffect(() => {
    const sessionData = getSession();
    setSessionState(sessionData);

    if (sessionData?.loginTime) {
      const updateTime = () => {
        const loginTime = new Date(sessionData.loginTime);
        const now = new Date();
        const diff = now - loginTime;
        const hours = Math.floor(diff / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        setSessionTime(`${hours}h ${minutes}m`);
      };

      updateTime();
      const interval = setInterval(updateTime, 60000); // Update every minute
      return () => clearInterval(interval);
    }
  }, []);

  const handleLogout = () => {
    clearSession();
    navigate('/login-and-authentication');
  };

  // Get role display name
  const getRoleDisplay = (role) => {
    const roleNames = {
      admin: 'Administrador',
      operator: 'Operador',
      auditor: 'Auditor'
    };
    return roleNames[role] || 'Usuario';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-elevation">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo */}
        <Link to="/dashboard-overview" className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
            <Icon name="Car" size={20} color="white" />
          </div>
          <div className="flex flex-col">
            <span className="text-lg font-semibold text-foreground">VIN Pro</span>
            <span className="text-xs text-muted-foreground -mt-1">Platform</span>
          </div>
        </Link>

        {/* User Session Status */}
        <div className="flex items-center space-x-4">
          <div className="hidden sm:flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>Sesión: {sessionTime}</span>
          </div>

          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <Icon name="User" size={16} color="white" />
            </div>
            <div className="hidden sm:block">
              <div className="text-sm font-medium text-foreground">
                {session?.userName || 'Usuario'}
              </div>
              <div className="text-xs text-muted-foreground">
                {getRoleDisplay(session?.role)}
              </div>
            </div>
          </div>

          <Button
            variant="ghost"
            size="sm"
            iconName="LogOut"
            iconSize={16}
            className="text-muted-foreground hover:text-foreground"
            onClick={handleLogout}
          >
            <span className="hidden sm:inline">Salir</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;